import React, { useState, useEffect, useRef } from "react";
import DatePicker from "react-datepicker";
import AccountDropdown from "../common/controls/AccountDropdown";
import DateUtil from "../../common/dateUtil";
import "react-datepicker/dist/react-datepicker.css";


const PreTradeFormBond = (props) => {


  //  console.log(props.metadata);

  const node = useRef();

  const [showTxtFinName, setShowTxtFinName] = useState(false);
  const [limitStopDisabled, setLimitStopDisabled] = useState(true);

  const [dropdownOpen, setDropdownOpen] = useState(false);



  useEffect(() => {
    setShowTxtFinName(props.data.finInstituteId === "OTHER");
  }, [props.data.finInstituteId]);

  useEffect(() => {
    setLimitStopDisabled(
      props.data.orderType === "" || props.data.orderType === "Market Order"
    );
  }, [props.data.orderType]);


  const handleNumberField4DecimalChange = (e) => {
    if (/^\d+\.?\d{0,4}$/.test(e.target.value) || e.target.value === "") {
      props.handleChange(e);
    }
  };

  const handleNumberField2DecimalChange = (e) => {
    if (/^\d+\.?\d{0,2}$/.test(e.target.value) || e.target.value === "") {
      props.handleChange(e);
    }
  };

  useEffect(() => {
    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutsideDropdown);
    } else {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDropdown);
    };
  }, [dropdownOpen]);

  const handleClickOutsideDropdown = e => {
    console.log("clicking anywhere");
    if (node.current.contains(e.target)) {
      return;
    }
    setDropdownOpen(false);
  };


  return (

        <div className="form-items">

          <div className="form-columns">

            <div className="form-column">

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.account ? "" : "warning"}`}>Select an Account :</label>
                <div className="wrapper-demo form-item-value">
                  <div ref={node} className={dropdownOpen ? "wrapper-dropdown-1 active" : "wrapper-dropdown-1"} onClick={p => setDropdownOpen(!dropdownOpen)}>

                    {props.data.account ?
                      props.data.account.accountNumber && props.data.account.brokerDealerName ? <><span>{props.data.account.accountNumber}</span>::<span>{props.data.account.brokerDealerName}</span></> : <span>Other...</span>
                      : (<span>Select an Account</span>)}
                    <span></span>
                    <AccountDropdown accounts = {props.metadata.accounts} selectionChanged={props.handleAccountSelectionChanged}/>
                  </div>
                </div>
              </div>

              {props.data.account && !props.data.account.accountNumber &&
                <>
                  <div className="form-item">
                    <label className={`form-item-label required ${props.validation.finInstituteId ? "" : "warning"}`} htmlFor="finInstituteId">
                      Financial Institution :
                        </label>
                    <div className="form-item-value">
                      <select className="full-width" name="finInstituteId" value={props.data.finInstituteId} onChange={props.handleChange}>
                        <option key="" value="">
                          (Choose a Financial Institution)
                            </option>
                        {props.metadata.finInstitute.map((fin) => (
                          <option key={fin.id} value={fin.id}>
                            {fin.name}
                          </option>
                        ))}
                        <option key="OTHER" value="OTHER">
                          Other...
                            </option>
                      </select>
                      {showTxtFinName && (
                        <input
                          className="full-width"
                          type="text"
                          name="finInstitute"
                          id="txtFinName"
                          maxLength="250" 
                          value={props.data.finInstitute}
                          onChange={props.handleChange}
                          placeholder="Other Financial Institution"
                        />
                      )}
                    </div>
                  </div>

                  <div className="form-item">
                    <label
                      className={`form-item-label required ${props.validation.accountNumber ? "" : "warning"
                        }`}
                      htmlFor="accountNumber"
                    >
                      Account Number :
                        </label>
                    <input
                      className="form-item-value"
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      maxLength="50" 
                      value={props.data.accountNumber}
                      onChange={props.handleChange}
                    />
                  </div>


                </>

              }

              <div className="form-item">
                <label className={`form-item-label`} htmlFor="cusip">
                  CUSIP :
                </label>
                <input className="form-item-value" type="text" id="cusip" name="cusip" maxLength="100" value={props.data.cusip} onChange={props.handleChange}/>
              </div>
              <div className="form-item">
                <label className={`form-item-label required ${props.validation.securitySymbol ? "" : "warning"}`} htmlFor="securitySymbol">
                  Security Symbol :
                </label>
                <input className="form-item-value" type="text" id="securitySymbol" name="securitySymbol" maxLength="50" value={props.data.securitySymbol} onChange={props.handleChange}/>
              </div>

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.quantity ? "" : "warning"}`} htmlFor="quantity">
                  Quantity :
              </label>
                <input className="form-item-value" type="text" id="quantity" name="quantity" value={props.data.quantity} onChange={handleNumberField4DecimalChange}/>
              </div>
              
              <div className="form-item">
                <label className="form-item-label" htmlFor="quantity">
                  Dollar amount :
              </label>
              <input className="form-item-value" type="text" id="dollarAmount" name="dollarAmount" value={props.data.dollarAmount} onChange={handleNumberField4DecimalChange}/>
              </div>

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.securityDesc ? "" : "warning"}`} htmlFor="securityDesc">
                  Security Description :
              </label>
                <input className="form-item-value" type="text" id="securityDesc" name="securityDesc" maxLength="500" value={props.data.securityDesc} onChange={props.handleChange}/>
              </div>



            </div>

            <div className="form-column">

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.tradeDate ? "" : "warning"}`} htmlFor="tradeDate">
                  Intended Trade Date :
              </label>

                <div className="form-item-value">
                  <DatePicker selected={DateUtil.toDate(props.data.tradeDate)} onChange={props.handleDateChange}/>
                </div>
              </div>

              <div className="form-item">
                <label className={`form-item-label required ${props.validation.tradeAction ? "" : "warning"}`}>
                  Trade Action :
                </label>
                <div className="form-item-value label-group">
                  <label>
                    <input type="radio" name="tradeAction" value="B" className="form-check-input" checked={props.data.tradeAction === "B"} onChange={props.handleChange}/>
                  Buy
                </label>
                  <label>
                    <input type="radio" name="tradeAction" value="S" className="form-check-input" checked={props.data.tradeAction === "S"} onChange={props.handleChange}/>
                  Sell
                </label>
                  
                </div>
              </div>

              <div className="form-item">
                <label className="form-item-label" htmlFor="orderType">
                  Order Type :
                  </label>

                <select className="form-item-value" name="orderType" value={props.data.orderType} onChange={props.handleChange}>
                  <option value="">(Select Order Type)</option>
                  <option value="Market Order">Market Order</option>
                  <option value="Limit Order">Limit Order</option>
                  <option value="Stop Loss">Stop Loss</option>
                  <option value="Stop Limit">Stop Limit</option>
                </select>
              </div>

              <div className="form-item">
                <label className="form-item-label" htmlFor="limitStop">
                  Limit or Stop :
              </label>
                <input className="form-item-value" type="text" id="limitStop" name="limitStop" value={props.data.limitStop} onChange={handleNumberField2DecimalChange} disabled={limitStopDisabled ? "disabled" : ""}/>
              </div>

              <div className="form-item">
                <label className="form-item-label" htmlFor="timeForce">
                  Time in Force :
              </label>

                <select className="form-item-value" name="timeForce" value={props.data.timeForce} onChange={props.handleChange}>
                  <option value="">(Select Time in Force)</option>
                  <option value="Day">Day</option>
                  <option value="GTC">GTC</option>
                  <option value="On the Open">On the Open</option>
                  <option value="On the Close">On the Close</option>
                </select>
              </div>

            </div>

          </div>

        </div>

    );

};

export default PreTradeFormBond;
